const currencyFormatter = new Intl.NumberFormat('el-GR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
});

export default currencyFormatter;
